<template>
    <div class="main">
        <div class="actions">
            <router-link to="/orders" style="font-size:14px;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p>
                <p>Go Back To orders</p>

            </router-link>
        </div>
        <div style="display:flex;justify-content: center;">
            <img class="img_size" src="../../assets/img/filledoutline.png" />

        </div>
        <div style="text-align:center;padding-top:20.7px;font-size:20px">
            <h3>Request For Inventory from Cowtribe </h3>
        </div>
        <div style="padding-top:21px;background: #fff;height: 100%;padding: 46px;margin-bottom:30px;">
            <div style="text-align:center;">
                <p style="font-size:20px;line-height:32px">Please search and select the inventory you want to request
                </p>
            </div>
            <div>
                <div>
                    <a-form-model ref="addNewRequestInventoryForm" :model="newRequestInventoryform">
                        <a-row v-for="(request, index) in newRequestInventoryform.request" :key="request.key"
                            type="flex" justify="space-around">
                            <a-col :span="6">
                                <a-form-model-item label="Product Name" :prop="'request.' + index + '.productId'"
                                    :rules="{
                        required: true,
                        message: 'Please enter your product name',
                        trigger: 'blur',
                    }">
                                    <a-select show-search placeholder="Choose your product"
                                        option-filter-prop="children" v-model="request.productId"
                                        :filter-option="filterOption" @change="onCategoryChange(request)">
                                        <a-select-option v-for="product in products" :key="product.id"
                                            v-bind:value="product.id">
                                            {{ product.brandName }}
                                        </a-select-option>
                                    </a-select>

                                </a-form-model-item>
                            </a-col>
                            <a-col :span="4">
                                <a-form-model-item label="Price" :prop="'request.' + index + '.price'">
                                    <a-input-number class="rightSideinputText" type="number" disabled
                                        v-model="request.price" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="4">
                                <a-form-model-item label="Quantity" :prop="'request.' + index + '.quantity'" :rules="{
                        required: true,
                        message: 'Please enter your quantity',
                        trigger: 'blur',
                    }">
                                    <a-input-number :min="1" class="rightSideinputText" type="number"
                                        v-model="request.quantity" @change="onQuantityChange(request)" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="4">
                                <a-form-model-item label="Total" :prop="'request.' + index + '.total'">
                                    <a-input-number class="rightSideinputText" type="number" disabled
                                        v-model="request.total" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="2">
                                <div style="margin-top: 46px;">
                                    <a-icon v-if="newRequestInventoryform.request.length > 1"
                                        class="dynamic-delete-button" type="minus-circle-o"
                                        :disabled="newRequestInventoryform.request.length === 1"
                                        @click="removeDomain(request)" />
                                </div>
                            </a-col>

                        </a-row>

                        <a-form-model-item>
                            <a-button style="margin:0 auto;float: right; background:#418a49; color:#fff;"
                                @click="addDomain">
                                <a-icon type="plus" /> Add Product
                            </a-button>
                        </a-form-model-item>

                        <a-row>
                            <a-col :span="16">
                                <a-form-model-item label="Delivery Type" prop="deliveryType" :rules="{
                        required: true,
                        message: 'Please select your option',
                        trigger: 'blur',
                    }">
                                    <a-select placeholder="Choose your product"
                                        v-model="newRequestInventoryform.deliveryType" @change="onDeliveryTypeChange">
                                        <a-select-option value="0">
                                            Self Pickup
                                        </a-select-option>
                                        <a-select-option v-if="showDeliveryAddress" value="1">
                                            Deleiver to address
                                        </a-select-option>
                                    </a-select>

                                </a-form-model-item>
                                <div>
                                    <p style="color:#418a49;font-size:15px">
                                        {{ deliveryMsg }}
                                    </p>
                                </div>
                                <div style="display:flex;justify-content: center;padding-bottom: 10px;padding-top:20px">
                                    <a-spin class="spinner" :spinning="pickUpLooading" />
                                </div>
                                <div v-if="showPickUps">
                                    <p>Delivery Pickup Points</p>
                                    <a-list :grid="{ gutter: 16, column: 4 }" :data-source="pickupList">
                                        <a-list-item slot="renderItem" slot-scope="item">
                                            <a-tag color="#418a49">
                                                {{ item.name }}
                                            </a-tag>
                                        </a-list-item>
                                    </a-list>
                                </div>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="16">
                                <a-form-model-item label="Delivery Window">
                                    <a-select placeholder="Choose your delivery window"
                                        v-model="newRequestInventoryform.deliveryWindow"
                                        :disabled="disableSubmitButton">
                                        <a-select-option v-for="window in displayWindows" :key="window.id"
                                            v-bind:value="window.id">
                                            [ {{ window.description }} ] - Deliveries wiil be done between
                                            <b>{{ window.startDate }}</b> to <b>{{ window.endDate }}</b>
                                        </a-select-option>
                                    </a-select>

                                    <div>
                                        <p style="color:red;font-size:15px">
                                            {{ noDeliveryMsg }}
                                        </p>
                                    </div>
                                </a-form-model-item>

                            </a-col>
                        </a-row>
                    </a-form-model>


                </div>
                <div class="totalAmount">
                    <h3>Total Amount : <span style="font-size:32px;">Ksh {{ displayTotalAmount }}</span></h3>
                </div>
                <div style="display:flex;justify-content: center;padding-top: 40px;">
                    <a-button @click="showModal()" style="background: #418a49;height:45px;color:#fff;width:256px;">
                        Submit Request
                    </a-button>
                </div>
                <!-- Confirmation Modal -->
                <a-modal class="modalStyle" title="Request for Inventory?" :visible="visible"
                    :confirm-loading="confirmLoading" @ok="handleOk" :footer="null" @cancel="handleCancel">
                    <p style="font-size:16px">You are about to place an order for products worth <b>Ksh{{
                        displayTotalAmount }}</b></p>
                    <p style="font-size:16px">Do you want to proceed?</p>
                    <div style="display:flex;justify-content: center;padding-bottom: 10px;padding-top:20px">
                        <a-spin class="spinner" :spinning="loading" />
                    </div>
                    <div style="display: flex;justify-content: flex-end;">
                        <a-button @click="handleRequestInventory"
                            style="background: #418a49;color:#fff;border-radius:5px;">
                            Confirm
                        </a-button>
                    </div>
                </a-modal>

            </div>
        </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

const columns = [
    {
        key: 'productName',
        title: 'Product Name',
        width: 200,
        dataIndex: 'productName',
    },
    {
        key: 'price',
        title: 'Price',
        dataIndex: 'price',
        width: 200,
        scopedSlots: { customRender: 'price' },
    },
    {
        title: 'Action',
        key: 'action',
        width: 200,
        scopedSlots: { customRender: 'action' },
    },
];

export default {
    name: 'RequestInventory',
    data() {
        return {
            products: [],
            columns,
            searchText: '',
            visible: false,
            loading: false,
            confirmLoading: false,
            deliveryMsg: '',
            noDeliveryMsg: '',
            showDeliveryAddress: false,
            pickUpLooading: false,
            isWindowsEmpty: false,
            pickupList: [],
            showPickUps: false,
            deliveryZoneId: '',
            windows: [],
            distributionCentreName: '',
            distributionCentreAddress: '',
            form: {
                email: '',
                password: ''
            },
            // rules: {
            //     productId: [
            //         { required: true, message: 'Please choose your product' , trigger: 'change'},

            //     ],
            //     quantity: [
            //         { required: true, message: 'Please enter your quantity', trigger: 'change' },
            //         {   
            //                 pattern: new RegExp(/^[1-9]\d*$/), 
            //                 message: 'Please enter valid number', 
            //                 trigger: 'blur'
            //         },
            //     ]
            // },
            newRequestInventoryform: {
                request: [
                    {
                        productId: '',
                        quantity: '',
                        price: '',
                        total: '',
                        key: Date.now()
                    }
                ],
                deliveryType: '',
                deliveryWindow: ''
            }
        };
    },
    computed: {
        displayTotalAmount() {
            // console.log("in computed item |", this.newRequestInventoryform.request)
            const itemAmount = this.newRequestInventoryform.request.map(item => {
                if (item.price && item.quantity) {
                    return parseFloat(item.price) * item.quantity
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)

        },
        displayWindows() {
            // console.log("windows in compute | ", this.windows)
            return this.windows
        },
        disableSubmitButton() {
            return this.isWindowsEmpty
        }
    },
    methods: {
        ...mapActions(['getSystemProducts', 'addInventoryRequest', 'getRetailCenterProfile', 'getDeliveryPickupPoints', 'getDeliveryWindows']),
        showAddProductModal() {

        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    console.log('Received values of form: ', values);
                }
            });
        },
        showSelfPickMsg() {
            this.showPickUps = false;
            if (this.deliveryZoneId === null) {
                this.deliveryMsg = `Sorry you are out of our delivery zone. Kindly pickup your package at [ ${this.distributionCentreName}, ${this.distributionCentreAddress} ]`
            } else {
                this.deliveryMsg = `Kindly pickup your package at [ ${this.distributionCentreName}, ${this.distributionCentreAddress} ]`
            }
        },
        showDeliverAddresMsg() {
            this.deliveryMsg = ''
            this.pickUpLooading = true
            let request = {
                ZoneId: parseInt(this.deliveryZoneId)
            }
            // console.log("request | ", request)

            this.getDeliveryPickupPoints(request).then(response => {

                this.pickUpLooading = false
                response.status = 200
                if (response.status === 200) {
                    this.pickupList = response.data.data
                    this.showPickUps = true
                } else {
                    this.pickUpLooading = false
                    this.showErrorAlert('Something went wrong, try again later.')
                    // console.log("Error | ", response)
                }
            }, error => {
                this.pickUpLooading = false
                this.showErrorAlert('Something went wrong, try again later.')
                console.log("Error | ", error)
            })


        },
        onDeliveryTypeChange(value) {
            // console.log("value  | ", value)
            if (value === "0") {
                this.showSelfPickMsg()
            } else {
                this.showDeliverAddresMsg()
            }
        },
        showModal() {
            this.$refs.addNewRequestInventoryForm.validate(valid => {
                if (valid) {
                    this.visible = true;
                } else {
                    this.visible = false;
                    // console.log("Select plssssss")
                    // this.showErrorAlert("Please set quantity on your preferred product before selection")

                    return false;
                }
            });
        },
        handleOk() {
            this.confirmLoading = true;
            setTimeout(() => {
                this.visible = false;
                this.confirmLoading = false;
            }, 2000);
        },
        handleCancel() {
            // console.log('Clicked cancel button');
            this.visible = false;
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        handleRequestInventory() {
            this.loading = true;
            // console.log("newRequestInventoryform | ", this.newRequestInventoryform.request)
            let items = {}
            this.newRequestInventoryform.request.forEach(row => {
                items[row.productId] = row.quantity
            })

            // console.log("items | ", items)

            let request_data = {
                sourceLocationId: parseInt(process.env.VUE_APP_SOURCE_LOCATION_ID),
                items,
                deliveryType: parseInt(this.newRequestInventoryform.deliveryType),
                deliveryWindowId: this.newRequestInventoryform.deliveryWindow !== null ? parseInt(this.newRequestInventoryform.deliveryWindow) : this.newRequestInventoryform.deliveryWindow
            }
            // console.log("request_data | ", request_data)

            this.addInventoryRequest(request_data).then(response => {

                this.loading = false;
                if (response.status === 200) {
                    this.visible = false;
                    this.showSuccessAlert("Inventory Request Made Successfully");
                    this.newRequestInventoryform.request = [
                        {
                            productId: '',
                            quantity: '',
                            price: '',
                            total: '',
                            key: Date.now()
                        }
                    ]
                    this.$router.push('/orders').catch(() => { });
                } else {
                    this.showErrorAlert(response.data.messages);
                }
            },
                error => {
                    this.loading = false
                    this.showErrorAlert(JSON.stringify(error))
                })

        },
        addDomain() {
            this.newRequestInventoryform.request.push({
                productId: '',
                quantity: '',
                price: '',
                total: '',
                key: Date.now()
            });
        },
        removeDomain(item) {
            let index = this.newRequestInventoryform.request.indexOf(item);
            if (index !== -1) {
                this.newRequestInventoryform.request.splice(index, 1);
            }
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        onCategoryChange(item) {
            // console.log("item | ", item)

            this.products.forEach(product => {
                if (product.id === item.productId) {
                    // console.log("product | ", product)
                    item['price'] = parseFloat(product.sellingPrice).toFixed(2)
                }
            })
            this.onQuantityChange(item)
            this.newRequestInventoryform.request[item]
            // console.log("request | ", this.newRequestInventoryform.request)

        },
        onQuantityChange(item) {

            if (item['quantity']) {
                this.products.forEach(product => {
                    if (product.id === item.productId) {
                        item['total'] = parseFloat(parseFloat(item['price']) * parseFloat(item['quantity'])).toFixed(2)
                    }
                })
            } else {
                this.products.forEach(product => {
                    if (product.id === item.productId) {
                        item['total'] = 0.00
                    }
                })
            }
            this.newRequestInventoryform.request[item]
        },
        moment,
        getActiveWindows(data) {
            // console.log("data | ", data)
            let result = data.data;
            if (result) {
                result.forEach(window => {

                    let cutOffDate = moment(window.cutoffDate).format('YYYY-MM-DD')
                    let currentDate = moment().format('YYYY-MM-DD')
                    // console.log("cutOffDate | ", cutOffDate)
                    // console.log("currentDate | ", currentDate)
                    // console.log("comparison | ", moment(cutOffDate).isSameOrAfter(currentDate, 'day'))

                    if (moment(cutOffDate).isSameOrAfter(currentDate, 'day')) {
                        // console.log("add | ", window)
                        let windowObject = {
                            id: window.id,
                            description: window.description,
                            startDate: moment(window.startDate).format('DD-MM-YYYY'),
                            endDate: moment(window.endDate).format('DD-MM-YYYY')
                        }

                        this.windows.push(windowObject)
                    }
                })
            }
            // console.log("lenghth windows | ", this.windows.length)
            if (this.windows.length === 0) {
                // this.showErrorAlert('No Delivery Windows Available, try again later.')
                this.noDeliveryMsg = "No Delivery Windows Available"
                this.isWindowsEmpty = true
                this.newRequestInventoryform.deliveryWindow = null
            }
            // console.log("windows | ", this.windows)
        }
    },
    created() {
        if (this.getSystemProducts) {
            this.getSystemProducts().then(response => {

                this.products = response.data.data
            },
                error => {
                    console.log("error | ", error)
                })
        }
        if (this.getRetailCenterProfile) {
            this.getRetailCenterProfile().then(response => {
                // console.log("response retail details | ", response)
                if (response.status == 200) {
                    // response.data.deliveryZoneId = {}
                    if (response.data.deliveryZoneId === null) {
                        this.showDeliveryAddress = false;
                        this.newRequestInventoryform.deliveryType = "0"
                        this.deliveryZoneId = null
                        this.distributionCentreName = response.data.distributionCentreName
                        this.distributionCentreAddress = response.data.distributionCentreAddress
                        this.deliveryMsg = `Sorry you are out of our delivery zone. Kindly pickup your package at [ ${response.data.distributionCentreName}, ${response.data.distributionCentreAddress} ]`
                    } else {
                        this.showDeliveryAddress = true;
                        this.newRequestInventoryform.deliveryType = "0"
                        this.deliveryZoneId = response.data.deliveryZoneId
                        this.distributionCentreName = response.data.distributionCentreName
                        this.distributionCentreAddress = response.data.distributionCentreAddress
                        this.deliveryMsg = `Kindly pickup your package at [ ${response.data.distributionCentreName}, ${response.data.distributionCentreAddress} ]`
                    }
                } else {
                    // console.log("Error | ", response)
                }
            },
                error => {
                    console.log("error | ", error)
                })
        }
        if (this.getDeliveryWindows) {
            this.getDeliveryWindows().then(response => {
                // console.log("response window | ", response)
                if (response.status === 200) {
                    this.getActiveWindows(response.data);
                } else {
                    this.showErrorAlert("Something went wrong, try agian later.");
                    // console.log("Error | ", response)
                }
            }, error => {
                this.showErrorAlert("Something went wrong, try agian later.");
                console.log("Error | ", error)
            })
        }
    },

}
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
}

.img_size {
    max-width: 56px;
    max-height: 55px;
}

.rightSideinputText {
    width: 100%;
    border-radius: 5px;
}

.totalAmount {
    text-align: center;
    height: 93px;
    background: #eaec84;
    margin-left: 256px;
    font-size: 20px;
    margin-right: 256px;
    padding-top: 18px;
    margin-top: 25px;
    color: #266423;
}

.dropdownItem>>>.ant-select-selection__placeholder,
.ant-select-search__field__placeholder {
    line-height: 29px;
}

.dropdownItem>>>.ant-select-selection--single {
    position: relative;
    height: 45px;
    cursor: pointer;
}

.dropdownItem>>>.ant-select-selection-selected-value {
    line-height: 46px;
}

.requestInventoryTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.requestInventoryTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

button:hover,
button:active {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.requestInventoryTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.requestInventoryTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}
</style>
